import React from 'react';
import { RowingStats } from './types';

const RowingStatsComponent: React.FC<{ stats: RowingStats[] }> = ({
  stats
}) => {
  return (
    <div className='card'>
      <div className='card-body'>
        <h5 className='card-title'>Rowing Statistics</h5>
        <div className='card-text'>
          <table className='table table-bordered'>
            <tbody>
              <tr>
                <th scope='row'>Arm</th>
                {stats.map(s => (
                  <td key={s.arm}>{s.arm}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Sessions</th>
                {stats.map(s => (
                  <td key={s.arm}>{s.sessions.toLocaleString()}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Average Score</th>
                {stats.map(s => (
                  <td key={s.arm}>{(s.averageScore || 0).toLocaleString()}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Max Score</th>
                {stats.map(s => (
                  <td key={s.arm}>{(s.maxScore || 0).toLocaleString()}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Rows</th>
                {stats.map(s => (
                  <td key={s.arm}>{s.rows.toLocaleString()}</td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Average Pull In Time</th>
                {stats.map(s => (
                  <td key={s.arm}>
                    {(s.avgPullInDuration || 0).toLocaleString()}
                  </td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Average Push Out Time</th>
                {stats.map(s => (
                  <td key={s.arm}>
                    {(s.avgPushOutDuration || 0).toLocaleString()}
                  </td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Min Left Arm Angle</th>
                {stats.map(s => (
                  <td key={s.arm}>
                    {(s.avgMinLeftAngle || 0).toLocaleString()}
                  </td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Max Left Arm Angle</th>
                {stats.map(s => (
                  <td key={s.arm}>
                    {(s.avgMaxLeftAngle || 0).toLocaleString()}
                  </td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Min Right Arm Angle</th>
                {stats.map(s => (
                  <td key={s.arm}>
                    {(s.avgMinRightAngle || 0).toLocaleString()}
                  </td>
                ))}
              </tr>
              <tr>
                <th scope='row'>Max Right Arm Angle</th>
                {stats.map(s => (
                  <td key={s.arm}>
                    {(s.avgMaxRightAngle || 0).toLocaleString()}
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export { RowingStatsComponent };
